// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Intervals } from './Instruments/Intervals';
import { MathUtils } from './MathUtils';
export class _NumericUtils {
    constructor() {
        this.MINVALUE = -999999999;
        this.MAXVALUE = 999999999;
    }
    getPriceNumericParameters(instrument) {
        if (isNullOrUndefined(instrument)) {
            return { min: 0, max: 0, step: 0, precision: 0 };
        }
        const max = this.MAXVALUE;
        const precision = instrument.getDefaultPrecision();
        const step = instrument.getPointSize(null);
        const intervals = Intervals.GetIntervalsFromInstrument(instrument, max);
        const min = isValidArray(intervals) ? intervals[0].LeftValue : step;
        return { min, max, step, precision };
    }
    valueUpDownChangeProcess(isUp, currentValue, remainingSteps, minValue, maxValue) {
        const direction = isUp ? 1 : -1;
        let value = currentValue + direction * remainingSteps;
        if (value < minValue) {
            value = minValue;
        }
        else if (value > maxValue) {
            value = maxValue;
        }
        const valuePrecision = MathUtils.GetDecimalPlaces(currentValue);
        const stepPrecision = MathUtils.GetDecimalPlaces(remainingSteps);
        const precision = Math.max(valuePrecision, stepPrecision);
        return MathUtils.Round(value, precision);
    }
    getInterval(intervals, value) {
        return this.getIntervalCore(intervals, value, (i) => i.ValueInInterval(value));
    }
    getIntervalUpDown(intervals, value, currentMoveType) {
        return this.getIntervalCore(intervals, value, (i) => i.ValueInIntervalUpDown(value, currentMoveType));
    }
    getIntervalCore(intervals, value, matches) {
        if (!isValidArray(intervals)) {
            return null;
        }
        for (const element of intervals) {
            if (matches(element)) {
                return element;
            }
        }
        const last = intervals.at(-1);
        const first = intervals[0];
        if (last !== undefined && value >= last.RightValue) {
            return last;
        }
        if (value <= first.LeftValue) {
            return first;
        }
        return null;
    }
}
export const NumericUtils = new _NumericUtils();
